<div *ngIf="visible" class="snackbar" [ngClass]="backgroundColor" [@toggle]>
	<div class="snackbar__content">
		<div class="snackbar__icon">
			<svg class="snackbar__icon--good">
				<use xlink:href="../../../assets/img/sprite.svg#icon-Check"></use>
			</svg>
			<svg class="snackbar__icon--error">
				<use xlink:href="../../../assets/img/sprite.svg#icon-exclamation-mark"></use>
			</svg>
			<svg class="snackbar__icon--warning">
				<use xlink:href="../../../assets/img/sprite.svg#icon-Emark"></use>
			</svg>
		</div>
		<div class="snackbar__body" [class.snackbar__body--inline]="action?.underlineLink">
			<p class="snackbar__text" data-cy="snackbar__text"
			[innerHTML]="text"></p>
			@if (action) {
				<button (click)="invokeAction()" class="snackbar__action-btn"
					[class.snackbar__action-btn--link]="action.underlineLink" color="tertiary" mine-button>
					{{ action.text }}
				</button>
			}
		</div>
	</div>

	<button *ngIf="dismissible" class="snackbar__dismiss" 
		data-cy="snackbar__dismiss" (click)="onDismiss()">

		Hide
		
	</button>
	
</div>